import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";

import { useAlert } from "react-alert";

import withClass from "../../../../../../hoc/withClass";
import Icon from "../../../../../UI/Icon/Icon";
import Dropzone from "./Dropzone/Dropzone";
import AiSearch from "./AiSearch/AiSearch";
import Results from "./AiSearch/Results/Results";
import Answer from "./AiSearch/Answer/Answer";

/**MUI componets */

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";

/**Project Components */
import SlidingPane from "../../../../../UI/SlidingPane/SlidingPane";
import context from "../../../../../../context/auth-context";

const Ai = () => {
  const [openWindow, setOpenWindow] = useState(null);
  const [aiPaneOpen, setAiPaneOpen] = useState(false);
  const [checked, setChecked] = useState(true);
  const [serachResults, setSerachResults] = useState(false);
  const [value, setValue] = React.useState(0);

  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  const authContext = useContext(context);
  const { accessToken, companyId, companyName, tokenIsValid } = authContext;

  const aiPaneCloseHandler = () => {
    setAiPaneOpen(false);
    return;
  };

  // const alert = useAlert();
  const aiActivitiesClickHandler = () => {
    setAiPaneOpen(true);
    return;
  };
  const handleSearchClick = () => {
    setOpenWindow("search");
  };

  const handleUploadClick = () => {
    setOpenWindow("upload");
  };

  const handleCheck = () => {
    checked ? setChecked(false) : setChecked(true);
  };

  const handleAsk = (value) => {
    const result = async () =>
      await axios.post("https://ai_search.stl-horizon.com/api/ask", {
        query: value,
      });
    result()
      .then((response) => {
        if (response) {
          setData(response.data.data);
          // console.log(response.data.data, "findings");
          // alert.show(response.data.message, { type: "success" });
          alert(response.data.message);
          setSerachResults(true);
        }
      })
      .catch(() => {
        setError(true);
        // alert.show("There was an error", { type: "error" });
        alert("There was an error!")
      });
  };
  return (
    <>
        <span
          className="nav-link"
          id="mega-menu"
          // data-toggle="dropdown"
          // aria-expanded="false"
          // data-animation="fade"
          role="button"
          onClick={aiActivitiesClickHandler}
          style={{ cursor: "pointer" }}
        >
          Ai Search <Icon iconClass="icon md-chevron-down" color="white" />
        </span>
        <SlidingPane
          open={aiPaneOpen}
          width="93.5%"
          title="Ai File Activities"
          subtitle={`${companyName}`}
          onRequestClose={aiPaneCloseHandler}
          closeIcon={
            <i
              className="icon ti-close animation-scale-up"
              style={{ fontWeight: 700 }}
              aria-hidden="true"
            ></i>
          }
        >
          <Box>
            <Box className="row" sx={{ margin: "20px" }}>
              <div className="col-md-3">
                <h4>Ai File Activities</h4>
              </div>
            </Box>
            <Box className="row" sx={{ margin: "20px" }}>
              <Box className="col-md-2" sx={{ backgroundColor: "#F3F3F3" }}>
                <List>
                  <Stack>
                    <ListItemButton onClick={handleUploadClick}>
                      Upload File
                      <ListItemText />
                    </ListItemButton>
                    <ListItemButton onClick={handleSearchClick}>
                      Search
                      <ListItemText />
                    </ListItemButton>
                  </Stack>
                </List>
              </Box>
              <div className="col-md-10">
                <div className="container">
                  <div className="row">
                    {openWindow && openWindow === "upload" ? (
                      <Dropzone />
                    ) : null}
                    {openWindow && openWindow === "search" ? (
                      <AiSearch
                        handleCheck={handleCheck}
                        checked={checked}
                        handleAsk={handleAsk}
                      />
                    ) : null}
                  </div>
                  <div className="row">
                    {openWindow &&
                    openWindow === "search" &&
                    serachResults &&
                    checked ? (
                      <Answer data={data} />
                    ) : null}
                  </div>

                  {openWindow && openWindow === "search" && serachResults ? (
                    <>
                      {Object.keys(data.retrieval_results.resources).map(
                        (key) => (
                          <div key={key} className="row">
                            <Results
                              resource={data.retrieval_results.resources[key]}
                            />
                          </div>
                        )
                      )}
                    </>
                  ) : null}
                </div>
              </div>
            </Box>
          </Box>
        </SlidingPane>
    </>
  );
};

export default withClass(Ai, "nav-item dropdown dropdown-fw dropdown-mega");
